<template>
  <component
    :is="is"
    class="video-list__video-item m-[1.5vw] video-preview-box rounded-bl-none"
  >
    <router-link
      :to="to"
      class="video-list__video-item__link relative items-center flex flex-col h-full"
      :class="computedSchoolLevelBackgroundColor"
    >
      <img
        :src="transformPublicUrl(video.previewImage?.publicUrl)"
        :alt="video.title"
        :title="video.title"
        class="max-w-[21vw]"
      />
      <div
        class="video-list__video-item__title video-preview-box__title text-almostBlack self-stretch grow pl-[13px] pt-[8px] pb-[15px] text-left"
      >
        <div class="font-sans pb-[2px] text-[14px]">{{ splitTitle[0] }}</div>
        <div class="font-bree text-[14px]">{{ splitTitle[1] }}</div>
      </div>
    </router-link>
  </component>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";

import findBySlug from "../../../store/getters/resolve/find-by-slug";

export default {
  name: "VideoPreview",
  props: {
    to: {
      type: Object,
      required: true,
    },
    video: {
      type: Object,
      required: true,
    },
    is: {
      type: String,
      default: "div",
    },
  },
  computed: {
    ...mapState(["container"]),
    tags() {
      return this.video.tags?.map((tag) =>
        findBySlug(this.container?.tags, tag.slug),
      );
    },
    splitTitle() {
      const parts = this.video.title.split(":");
      return parts.length > 1
        ? [parts[0].trim(), parts[1].trim()]
        : [this.video.title];
    },
    computedSchoolLevel() {
      const slug = this.$route.params.schoolLevelSlug;
      return findBySlug(this.container?.schoolLevels, slug);
    },
    computedSchoolLevelBackgroundColor() {
      const slug = this.computedSchoolLevel?.slug;
      if (!slug) return "";
      const bgMap = {
        onderbouw: "bg-yellow-200 hover:bg-yellow",
        "midden-bovenbouw": "bg-yellowGreen-200 hover:bg-yellowGreen",
      };

      return bgMap[slug] || "";
    },
  },
  methods: {
    transformPublicUrl: (url) => (url?.includes("://") ? url : `/${url}`),
  },
};
</script>
